import router from '@/router'
import store from '@/store'
// 2026-09-17：取消平台初始化栏目后，旧直链回到平台信息，保留底层模板数据。
import { isRetiredPlatformMenu } from '@/utils/platformAdministration'
// 2026-09-22：功能设置有独立编辑权限，分店和无授权账号直链也不能进入。
import { canConfigureFunctionGuides } from '@/utils/functionGuides'
import sysRequest from '@/api/sys'
import { canAccessManagementRoute, firstAccessibleManagementPath, PERMISSION_DENIED_PATH } from '@/utils/managementRouteAccess'
/**
 * 免登录白名单
 */
// 2026-09-03：维护应急入口必须在未登录时可达，页面内部再严格校验平台超级管理员身份。
const whiteList:string[] = ['/login','/basy','/maintenance-access']
/**
 * 路由前置处理
 */
router.beforeEach(async (to, from, next) => {
  if (store.getters.token) {
    if (to.path === '/login') {
      next('/')
      return
    }
    if(!store.getters.hasUserInfo){
      await store.dispatch('user/getUserInfo')
    }
    if(isRetiredPlatformMenu(store.getters.userInfo,{functionUrl:to.path})){
      next('/platform/platforminfo')
      return
    }
    if(to.path===PERMISSION_DENIED_PATH || to.path==='/maintenance-access'){
      next()
      return
    }
    // 每次进入业务页面重新读取有效权限；旧缓存不能放行已撤销的VIP或员工授权。
    const identity=()=>JSON.stringify([store.getters.token,store.getters.userInfo?.id,store.getters.userInfo?.orgId,store.getters.userInfo?.roleId])
    const startedAs=identity()
    try{
      const response=await sysRequest.getEffectiveFunctions()
      if(startedAs!==identity()){next(false);return}
      if(!Array.isArray(response.data))throw new Error('权限读取失败')
      const functions=response.data
      store.commit('user/setFunctions',{...store.getters.functions,allFunc:functions})
      store.commit('user/setSysFunctions',functions.filter(item=>item.functionType==='FUNC').reduce((result,item)=>{
        result[item.functionKey]=item
        return result
      },{}))
      if(!canAccessManagementRoute(to.path,functions,store.getters.printData)){
        // 登录默认首页未授权时落到实际可用菜单，避免有权限的员工被困在默认首页。
        if(to.path==='/platform/platforminfo' && (!from.path || from.path==='/' || from.path==='/login')){
          const target=firstAccessibleManagementPath(functions,path=>router.resolve(path).matched.length>0)
          next({path:target,replace:true})
          return
        }
        next({path:PERMISSION_DENIED_PATH,replace:true})
        return
      }
    }catch(error){
      // 读取失败不沿用旧授权；保留登录和业务数据，允许用户重新检查。
      if(startedAs!==identity()){next(false);return}
      store.commit('user/setFunctions',{parentFunc:[],allFunc:[]})
      store.commit('user/setSysFunctions',{})
      next({path:PERMISSION_DENIED_PATH,replace:true})
      return
    }
    // 2026-09-20：系统参数设置直链仅平台可进，分店旧菜单缓存不能放行。
    if(to.meta.requiresPlatform && Number(store.getters.userInfo.orgId) !== 1000){
      next('/')
      return
    }
    // 2026-08-18：分店 B 端权限是跨机构配置，仅平台超级管理员可进入；后端同时强制校验。
    if(to.meta.requiresPlatformSuperAdmin
      && (store.getters.userInfo.orgId !== 1000 || store.getters.userInfo.roleId !== 1)){
      next('/')
      return
    }
    // 2026-08-30：VIP角色总控统一使用平台超管路由守卫，不再接受任何分店有效功能或历史缓存放行。
    if(to.meta.requiresFunctionGuides && !canConfigureFunctionGuides(store.getters.userInfo,store.getters.functions?.allFunc)){
      next('/')
      return
    }
    next()
  } else {
    if (whiteList.indexOf(to.path) > -1) {
      next()
    } else {
      next('/login')
    }
  }
})
